// extracted by mini-css-extract-plugin
export default {"AddContractClauseModal":"AddContractClauseModal_AddContractClauseModal__n-sHM"};